// src/components/agent/CreateAgentModal.jsx
import React from 'react';
import CreateAgentForm from './CreateAgentForm';
import { XMarkIcon } from '@heroicons/react/24/outline';

const CreateAgentModal = ({ isOpen, onClose, onAgentCreated }) => {
  if (!isOpen) {
    return null;
  }

  const handleFormSuccess = () => {
    if (onAgentCreated) {
      onAgentCreated();
    }
    onClose(); 
  };

  return (
    // Overlay
    <div 
      className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4 transition-opacity duration-300 ease-in-out"
      onClick={onClose} 
    >
      <div
        className="bg-slate-800 rounded-xl shadow-2xl w-full max-w-2xl border border-slate-700 relative animate-fadeIn p-0 max-h-[90vh] flex flex-col"
        onClick={(e) => e.stopPropagation()} 
      >
        {/* Header Modal */}
        <div className="flex items-center justify-between p-5 sm:p-6 border-b border-slate-700">
          <h2 className="text-xl sm:text-2xl font-semibold text-slate-100">
            Create New AI Agent
          </h2>
          <button
            onClick={onClose}
            className="p-1.5 rounded-full text-slate-400 hover:bg-slate-700 hover:text-slate-100 transition-colors"
            aria-label="Close modal"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>

        <div className="overflow-y-auto p-5 sm:p-6">
          <CreateAgentForm onSuccess={handleFormSuccess} onCancel={onClose} />
        </div>
      </div>
    </div>
  );
};

export default CreateAgentModal;